export default "/static/media/icon-trash.ef947b6a.svg";